<script lang="ts">
	import { t } from '$i18n/i18n'
	import { ButtonIcons, LoadingAnimation } from '$types/enums'
	import { addNotification, showAnimation } from '../stores'
	import { NotificationType } from '$types/notification'
	import PrimaryButton, {PrimaryBtnColors} from "../atoms/PrimaryButton.svelte";

    export let updateFun = () => {
    };
    export let uploadUrl: string;
    export let disabled: boolean = false;

	let fileInput: HTMLInputElement
	let files

	$: if (files) {
		multiUpload(files)
	}

	async function multiUpload(files) {
		// should only be one
		for (const file of files) {
			await upload(file)
		}
	}

	async function upload(file) {
		showAnimation(LoadingAnimation.AiUpload)

		let formData = new FormData()
		formData.append('fileName', file.name)
		formData.append('fileData', file)

        let response = await fetch(uploadUrl, {
            method: "POST",
            body: formData,
        });
        let responseBody = await response.json();
        if (responseBody.success) {
            if (!responseBody.data) {
                console.error('No traceId found in response');
                return;
            }
            updateFun();
        } else {
            let notification = {
                message: $t('UI.FileUploadDD.uploadError'),
                type: NotificationType.ERROR,
                timeout: 0,
                dismissible: true
            };
            addNotification(notification);
        }
    }
</script>

<PrimaryButton
	label={$t('UI.map.createAnalytical.ai')} color={PrimaryBtnColors.GREEN}
	leftIcon={ButtonIcons.UPLOAD} {disabled}
               iconGap="0.5rem" sizeAdaptingToText
	on:click={() => fileInput.click()}
/>
<input
	style="display:none"
	type="file"
	bind:this={fileInput}
	bind:files
	on:click={(e) => {
		e.target.value = ''
		files = null
	}}
/>